export const ADMIN_ACTION_PASSWORD_MIN_LENGTH = 8;

export const FLAG_KEY_REGEX = /^[a-z][a-z0-9_]{0,63}$/;
